export const breadcrumbs = {
  ml: "15px",
};

export const levels = {
  color: "#616161",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "unset",
  alignItem: "center",
};
